<div class="container-fluid">
  <div class="alert alert-warning p-4 my-5">
    <p class="display-6 text-center my-0">
        Du är ej behörig.
    </p>
  </div>
</div>